import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { actions } from '../redux/modules/frontPage';
import useSelector from '../redux/typedHooks';
import { useAuth0Token } from './useAuth0Token';
import { resolveFrontPageWeight } from './useFrontPage.utils';

// Get a document with the given slug
export const useFrontPage = (abTestWeight?: number) => {
  const { simpleToken } = useAuth0Token();

  const returnValue = useSelector((state) => state.frontPage) || {
    data: undefined,
    meta: { isUpdating: undefined, isLoggedin: undefined, fetchedAt: undefined },
    error: undefined,
  };
  const {
    meta: { fetchedAt, isUpdating, isLoggedin },
  } = returnValue;

  const dispatch = useDispatch();

  useEffect(() => {
    const weight = resolveFrontPageWeight(abTestWeight);
    const now = new Date().getTime();
    const age = (fetchedAt && now - new Date(fetchedAt).getTime()) || 3600000;
    if ((!fetchedAt && !isUpdating) || age > 1800000 || (!isLoggedin && typeof simpleToken === 'string')) {
      dispatch(actions.getFrontPage.request(undefined, { token: simpleToken, abTestWeight: weight }));
    }
  }, [simpleToken, dispatch, fetchedAt, isLoggedin, isUpdating, abTestWeight]);

  return returnValue;
};
